import { Collapse, Dialog, DialogContent, IconButton } from '@material-ui/core';
import Close from '@material-ui/icons/Close';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import CircularProgressCustom from '@orientaction/components/CircularProgressCustom';
import { ReactNode, useState } from 'react';
import RedesignImage from '../../../../../shared/components/RedesignImage';
import { useDetailModalStyles } from './DetailModal.styles';

export const Html = ({ text }: { text?: string }) =>
  text ? <div dangerouslySetInnerHTML={{ __html: text }} /> : null;

export const ContentList = ({ items }: { items?: string[] | string }) =>
  Array.isArray(items) ? (
    <ul>
      {items.map(item => (
        <li key={item}>
          <Html text={item} />
        </li>
      ))}
    </ul>
  ) : (
    <Html text={items} />
  );

type DetailModalProps = {
  open: boolean;
  onCancel: () => void;
  label: string;
  img: string;
  color: string;
  value: number;
  totalValue?: number;
  isPercent?: boolean;
  introduction: ReactNode;
  children: ReactNode;
};

const DetailModal = ({
  open,
  onCancel,
  label,
  img,
  color,
  value,
  totalValue = 100,
  isPercent = false,
  introduction,
  children,
}: DetailModalProps) => {
  const classes = useDetailModalStyles();
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      fullWidth={true}
      maxWidth={false}
      classes={{ paper: classes.paper }}
      aria-labelledby="major-detail-title">
      <DialogContent className={classes.content}>
        <IconButton className={classes.close} onClick={onCancel} aria-label="Fermer">
          <Close fontSize="small" />
        </IconButton>
        <div className={classes.header}>
          <div className={classes.illustration}>
            <div className={classes.label} style={{ backgroundColor: color }}>
              <span id="major-detail-title">{label}</span>
            </div>
            <RedesignImage priority={true} src={img} alt={label} className={classes.image} />
          </div>
          <div className={classes.introduction}>
            <CircularProgressCustom
              value={value}
              color={color}
              size={110}
              fontSize={26}
              fontSizeFloat={12}
              isPercent={isPercent}
              totalValue={totalValue}
              calculatedValue={(value * 100) / totalValue}
            />
            {introduction}
          </div>
        </div>
        {children}
      </DialogContent>
    </Dialog>
  );
};

type AdviceProps = {
  index: number;
  title: string;
  children: ReactNode;
};

export const Advice = ({ index, title, children }: AdviceProps) => {
  const [open, setOpen] = useState(true);
  const classes = useDetailModalStyles();
  const contentId = `major-advice-${index}`;
  return (
    <div className={classes.accordion}>
      <button
        type="button"
        className={classes.toggle}
        aria-expanded={open}
        aria-controls={contentId}
        onClick={() => setOpen(!open)}>
        <span className={classes.number}>{index}</span>
        <span>{title}</span>
        {open ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
      </button>
      <Collapse in={open}>
        <div id={contentId} className={classes.accordionBody}>
          {children}
        </div>
      </Collapse>
    </div>
  );
};

// Paths copied from the quotation icon in the Paper Harmony modal (MSO-0).
export const QuoteIcon = () => (
  <svg width="72" height="52" viewBox="0 0 72 52" aria-hidden="true">
    <path
      d="M8 52 C4 52 0 48 0 42 L0 24 C0 12 8 4 20 0 L26 8 C18 12 14 18 14 24 L14 24 L20 24 C24 24 28 28 28 32 L28 42 C28 48 24 52 20 52 Z"
      fill="#E5E5E5"
    />
    <path
      d="M40 52 C36 52 32 48 32 42 L32 24 C32 12 40 4 52 0 L58 8 C50 12 46 18 46 24 L46 24 L52 24 C56 24 60 28 60 32 L60 42 C60 48 56 52 52 52 Z"
      fill="#E5E5E5"
    />
  </svg>
);

export default DetailModal;
